import * as React from 'react'
import styled from 'styled-components'

const IconTextWrapper = styled.div`
  display: grid;
  grid-template-rows: 30px 1fr;
  align-content: center;
  align-items: center;
  justify-items: center;
  text-align: center;
  padding: 0.25rem;
  background-color: transparent;
  cursor: ${props => (!props.onClick ? 'default' : 'pointer')};
  outline: none;
  .icon {
    align-content: center;
    display: grid;
    i {
      font-size: 2rem;
      color: rgb(120, 120, 120);
    }
  }
  .text {
    font-size: 0.8rem;
    color: rgb(120, 120, 120);
  }
  &.active {
    .icon i {
      color: black;
    }
    .text {
      color: black;
    }
  }
`

const IconTextRow = styled(IconTextWrapper)`
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  text-align: left;
  .icon {
    display: grid;
    align-content: center;
    justify-items: center;
  }
  .text {
    font-size: 1rem;
    justify-self: start;
  }
`
const IconTextColumn = styled(IconTextWrapper)`
  width: 70px;
  grid-template-rows: auto 1fr;
  grid-row-gap: 0.5rem;

  .icon {
    align-content: center;
    display: grid;
  }
  .text {
    font-size: 0.9rem;
    white-space: nowrap;
  }
`

interface IconTextProps {
  /**
   * Icon file. Can be any component
   */
  icon: React.ReactNode
  /**
   * Text to show next to or under the icon
   */
  text: React.ReactNode
  /**
   * use this to set text under the icon
   */
  isColumn: boolean
  /**
   * if item should be clickable
   */
  onClick?: (e: React.MouseEvent) => void
  /**
   * is the item active
   */
  isActive: boolean
}

const IconText = (props: IconTextProps) => {
  return props.isColumn ? (
    <IconTextColumn onClick={props.onClick} className={props.isActive ? 'active' : undefined}>
      <span className="icon">{props.icon}</span>
      <span className="text">{props.text}</span>
    </IconTextColumn>
  ) : (
    <IconTextRow onClick={props.onClick} className={props.isActive ? 'active' : undefined}>
      <span className="icon">{props.icon}</span>
      <span className="text">{props.text}</span>
    </IconTextRow>
  )
}

IconText.defaultProps = {
  isColumn: false,
  isActive: true
}

export {IconText}
